import { QTextEdit } from "./QTextEdit";

export class QSearchStrDict {
  constructor() {}

  GetSectionKeys(sectionID) {
    if (!this[sectionID]) this[sectionID] = {};
    return this[sectionID];
  }

  ClearSection(sectionID) {
    if (sectionID != null) delete this[sectionID];
    else Object.keys(this).forEach(key => delete this[key]);
  }

  GetSearchStr(QTextEdit) {
    var sectionID = QTextEdit.fSectionID;
    var tabID = QTextEdit.fTabID;
    var searchKeys = this.GetSectionKeys(sectionID);
    if (searchKeys[tabID] == null) searchKeys[tabID] = "";
    return searchKeys[tabID];
  }

  UpdateSearchStr(QTextEdit, searchStr) {
    var sectionID = QTextEdit.fSectionID;
    var tabID = QTextEdit.fTabID;
    var sectionKeys = this.GetSectionKeys(sectionID);
    sectionKeys[tabID] = searchStr;
  }

  ClearSearchStr(QTextEdit) {
    this.UpdateSearchStr(QTextEdit, "");
  }
}
